import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { MirrorTest } from './components/MirrorTest';
import { ScienceSection } from './components/ScienceSection';
import { NerveDischarge } from './components/NerveDischarge';
import { NutritionSection } from './components/NutritionSection';
import { SleepSection } from './components/SleepSection';
import { ChecklistSection } from './components/ChecklistSection';
import { FaqSection } from './components/FaqSection';
export function App() {
  useEffect(() => {
    // Meta Pixel initialization
    ;
    (function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = true;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    (window as any).fbq('init', '949446444926722');
    (window as any).fbq('init', '889376187334814');
    (window as any).fbq('track', 'PageView');
  }, []);
  return <main className="w-full min-h-screen bg-cream selection:bg-gold selection:text-white" data-id="element-0">
      <HeroSection data-id="element-1" />
      <MirrorTest data-id="element-2" />
      <ScienceSection data-id="element-3" />
      <NerveDischarge data-id="element-4" />
      <NutritionSection data-id="element-5" />
      <SleepSection data-id="element-6" />
      <ChecklistSection data-id="element-7" />
      <FaqSection data-id="element-8" />
    </main>;
}